import { render, staticRenderFns } from "./RsaPazienteUscitePage.vue?vue&type=template&id=c081dc12"
import script from "./RsaPazienteUscitePage.vue?vue&type=script&lang=js"
export * from "./RsaPazienteUscitePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports